export const APP_NAME = 'Stashform'

// Marks the browser tab in development so it is not mistaken for production.
const DEV_PREFIX = '(dev) '

export function pageTitle(title?: string): string {
  const base = title ? `${title} · ${APP_NAME}` : APP_NAME
  return import.meta.env.DEV ? `${DEV_PREFIX}${base}` : base
}
